<template>
<v-container>
  <v-layout>
    <v-flex d-flex>
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="200"
          >
            <img
              style="backgroundColor: white"
              :src="profileImage"
            >
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h2 class="card-title font-weight-bold mb-0">
              <span v-show="!userProfile.GivenName"> Timesheets </span>
              <span v-show="userProfile.GivenName">Welcome</span>
              </h2>
            <h6 v-show="!userProfile.GivenName" class="text-none pt-0 mt-0"> Sign in using your Pipefish credentials. </h6>
            <h4 v-show="userProfile.GivenName" class="text-capitalize"> {{userProfile.GivenName}} {{userProfile.Surname}} </h4>
            <v-btn
              color="pipefishOrange"
              @click="login"
              v-if="!userProfile.GivenName"
            >
              Sign In
              <v-icon
                right dark
              >
                mdi-login
              </v-icon>
            </v-btn>
            <v-btn
              color="success"
              @click="proceed"
              v-else
            >
              Proceed
              <v-icon
                right dark
              >
                mdi-arrow-right-box
          </v-icon>
            </v-btn>
          </v-card-text>
        </material-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  mapActions,
  mapState,
mapMutations
} from 'vuex'
import axios from 'axios'
export default {
  data: () =>({
  }),
  created(){

  },
  computed: {
    ...mapState('api', ['profileImage']),
    ...mapState('app', ['userProfile']),
    ...mapState('admin', ['approvalObject'])
  },
  methods: {
    ...mapMutations('api', ['setProfileImage']),
    ...mapMutations('app', ['setUserProfile']),
    login() {
      this.$authService.login()
    },
    proceed() {
      this.$router.push({
        name: 'Timesheets',
        params: {
          userId: {
            id: this.userProfile.id,
            name: `${this.userProfile.GivenName} ${this.userProfile.Surname}`
          }
        }
      })
    },
    proceedToApprovals() {
      this.$router.push({
        name: 'Approval',
        params: {
          approval_id: this.approvalObject.params.approval_id,
          type: this.approvalObject.params.type,
          secret: this.approvalObject.params.secret
        }
      })
    },
  }

}
</script>

<style>

</style>
